import { Injectable } from '@angular/core';
import * as translation from './translation.json';

@Injectable({ providedIn: 'root' })
export class TranslationService {
  languageCode = 'en-US';

  constructor() {
    this.fetchLanguageCodeFromStorage();
  }

  translate(str, values = []) {
    const defaultLanguageCode = 'en-US';
    const languageCode = this.languageCode;

    let translationModule: any = translation;
    let translationDictionary = translationModule?.default[languageCode];

    // Use key(english text) as default
    let translatedStr = str;

    if (languageCode !== defaultLanguageCode) {
      // Get translated text from dictionary.
      if (typeof translationDictionary === 'undefined') {
        //console.warn(`${languageCode} language pack not available...`);
      } else {
        if (typeof translationDictionary[str] === 'undefined') {
          // console.warn(
          //   `${languageCode} translation for the following text is not available, please add`
          // );
          const _window: any = window;
          if (typeof _window?.missingTranslation === 'undefined') {
            _window.missingTranslation = [];
          }
          if (
            typeof _window?.missingTranslation[languageCode] === 'undefined'
          ) {
            _window.missingTranslation[languageCode] = {};
          }
          _window.missingTranslation[languageCode][
            str
          ] = `<Translate to ${languageCode}>`;
        } else {
          translatedStr = translationDictionary[str];
        }
      }
    }

    Object.keys(values).forEach((key) => {
      let replaceKey = values[key];
      translatedStr = translatedStr?.replaceAll(`{${key}}`, replaceKey);
    });

    return translatedStr;
  }

  getAvailableLanguage() {
    // return {
    //   'en-US': 'English',
    //   // 'ms-MY': 'Bahasa Malaysia',
    //   'zh-CN': 'Simplified Chinese',
    //   'zh-TW': 'Traditional Chinese',
    // };

    return [
      {
        languageCode: 'en-US',
        languageName: 'English',
        languageFlag: 'https://cdn.estore5s.com/asset/flags/us.png',
      },
      {
        languageCode: 'zh-CN',
        languageName: '简体中文',
        languageFlag: 'https://cdn.estore5s.com/asset/flags/cn.png',
      },
      {
        languageCode: 'zh-TW',
        languageName: '繁體中文',
        languageFlag: 'https://cdn.estore5s.com/asset/flags/tw.png',
      },
      {
        languageCode: 'id-ID',
        languageName: 'Bahasa Indonesia',
        languageFlag: 'https://cdn.estore5s.com/asset/flags/id.png',
      },
    ];
  }

  getLanguageCode() {
    return this.languageCode;
  }

  fetchLanguageCodeFromStorage() {
    let languageCode = localStorage.getItem('dashboardLanguageCode') ?? 'en-US';
    this.languageCode = languageCode;
  }

  changeLanguage(languageCode) {
    let foundLang = this.getLanguageByCode(languageCode);
    console.log({ foundLang });

    if (foundLang?.languageCode) {
      console.log(`Dashboard language changed to '${languageCode}'`);
      this.languageCode = foundLang?.languageCode;
      localStorage.setItem('dashboardLanguageCode', languageCode);
    }
  }

  getLanguageByCode(languageCode) {
    let availableLanguages = this.getAvailableLanguage();
    let availableLanguageCodes = Object.values(availableLanguages);

    return availableLanguageCodes.find((lang) => {
      return languageCode?.toLowerCase() === lang.languageCode?.toLowerCase();
    });
  }

  getCurrentLanguage() {
    return this.getLanguageByCode(this.languageCode);
  }
}
